import { render } from "./UppyUploader.vue?vue&type=template&id=2ab6f34c"
import script from "./UppyUploader.vue?vue&type=script&lang=js"
export * from "./UppyUploader.vue?vue&type=script&lang=js"

import "./UppyUploader.vue?vue&type=style&index=0&id=2ab6f34c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__